import Modifier from 'ember-modifier';

import { registerDestructor } from '@ember/destroyable';

import { ResizeObserver } from 'rise-ui/utils/resize-observer.js';

export default class OnResizeModifier extends Modifier {
  initialized = false;
  constructor() {
    super();
    registerDestructor(this, () => {
      this.resizeObserver?.unobserve(this._element);
    });
  }
  modify(element, [ callback ]) {
    if (!this.initialized) {
      this.initialized = true;
      this._element = element;
      this.resizeObserver = new ResizeObserver(entries => {
        this.callback?.(entries);
      });
      this.resizeObserver.observe(element);
    }
    this.callback = callback;
  }
}
